import React from "react";

const Button = ({
  text,
  size,
  color,
  onClick,
  className,
  children,
  ...props
}) => {
  const _color = `btn-${color || ""}`;
  const _size = `btn-${size || "md"}`;

  return (
    <button
      className={`btn ${_color} ${_size} ${className}`}
      onClick={onClick}
      type="button"
      {...props}
    >
      {text ? text : children}
    </button>
  );
};

export default Button;
